import { callAPIWhiteToken } from '../config/api';

const PATH_API = process.env.REACT_APP_API;

export async function trackWatch(data: {
	learningUniqueId: string;
	learningAssetsVideoUniqueId: string;
	isCompleted?: boolean;
	duration?: number;
}) {
	const url = `${PATH_API}/learning-users-video/watch`;
	return await callAPIWhiteToken({
		url,
		method: 'POST',
		data,
	});
}
